<template>
    <v-select 
       :value="selected_typecodes" 
       v-model="selectedtypecodes"
       v-bind:items="typecodes"
       item-value="code" 
       item-text="name" 
       :label="label"
       :dense="isDense" 
       :multiple="isMultiple"
       :clearable="isClearable"
       @change="updateData"
       v-on:click:clear="callClear()">
       <template v-slot:prepend-item v-if="canSelectAll">
            <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                    <v-icon :color="selectedtypecodes.length > 0 ? 'indigo darken-4' : ''"> {{ getIcon() }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.code }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selectedtypecodes.length - visibleChips }})</span>
        </template>                                                                    
    </v-select>
</template>

<script>
export default {
    props: {
        selected_typecodes: {
            type: Array,
            default: function() { return []; },
        },
        label: String,
        field: {
            default: 'type',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        }, 
        showInactive: {
            type: Boolean,
            default: false
        },
        isDense:{
            type: Boolean,
            default: false
        },
        vfyEmailsOnly:{
            type: Boolean,
            default: false
        },
        isAgent:{
            type: Boolean,
            default: false
        },
        visibleChips:{
            type: Number,
            default: 2
        },        
        canSelectAll: {
            type: Boolean,
            default: false
        },
        isMultiple: {
            type: Boolean,
            default: false
        },        
        localStorageItem:{
            type: String,
            default: 'list.acco.typecodes'
        }                
    }, 
    data() {
        return {
            typecodes: [],
            selectedtypecodes: [],
        }
    },
    created() {
        this.getTypeCodes();
    },
    methods: {
        callClear(){
            this.selectedtypecodes = [];
        },
        getIcon: function () {
            if (this.isAllSelected()) return 'mdi-close-box'
            if (this.isSomeSelected()) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },    
        isAllSelected: function () {
            return this.selectedtypecodes.length === this.typecodes.length; 
        },
        isSomeSelected: function () {            
            return this.selectedtypecodes.length > 0 && this.selectedtypecodes.length !== this.typecodes.length;
        },   
        toggle() {
            this.$nextTick(() => {
                if (this.isAllSelected()) {
                    this.selectedtypecodes = [];
                    this.updateData();
                } else {
                    this.selectAll();
                    this.updateData();
                }
            })
        },
        selectAll(){
            this.selectedtypecodes = [];
            this.typecodes.forEach(x => {
                this.selectedtypecodes.push(x.code);
            });
        }, 
        updateData(){              
            this.$emit('updateData', { "field": this.field, "value": this.selectedtypecodes })
        },        
        getTypeCodes() {
           
            this.typecodes = [
                {code: 'Real', name: 'Real'},
                {code: 'Test', name: 'Test'},
            ];
            if(localStorage.getItem(this.localStorageItem)!==null){
                this.selectedtypecodes=localStorage.getItem(this.localStorageItem).split(",");
            } else {
                this.selectAll();
            }
            this.updateData();                        
        },
    }
}
</script>